import * as React from 'react';

import { convertArrayFromDropdown } from '../../../../shared/helpers';
import { SelectPortal } from '../../../SelectPortal';

import HOCSettingsTooltip from './HOCSettingsTooltip';

export interface SettingsChoicesProps {
  name: string;
  pathOptions: string[];
  onChangeHandler: (e: any, data: any) => void;
  selection: boolean;
  currentValue: string;
  options: any;
  onChangeHandlerPortal: (name: string, value: any) => void;
  activeTab: number;
}

const PADDING_POPUP = 11;

class SettingsChoices extends React.Component<SettingsChoicesProps> {
  state = {
    menuTopHeight: 151,
    optionsSize: 30,
  };

  componentDidUpdate(prevProps: any) {
    if (this.props.activeTab !== prevProps.activeTab) {
      const element = document.querySelector('.editor-top-bar-left__settings-button');
      const bottom: number = element ? element.getBoundingClientRect().bottom : 0;
      this.setState({
        menuTopHeight: bottom + PADDING_POPUP,
      });
    }
  }

  handleData = (data: any) => {
    this.props.onChangeHandlerPortal(this.props.name, data);
  };

  render() {
    const { currentValue, name, options } = this.props;

    return (
      <SelectPortal
        className="code-editor-settings__form-element-dropdown dropdown-custom"
        value={currentValue}
        id={name}
        handle={this.handleData}
        options={convertArrayFromDropdown(options ? options.toJS() : [])}
        placeholder={currentValue}
        menuModifiers={['simulate-settings']}
        classNameOnScroll=".editor-top-bar-left__settings-popup"
        menuTopHeight={this.state.menuTopHeight}
        optionsSize={this.state.optionsSize}
      />
    );
  }
}
export default HOCSettingsTooltip(SettingsChoices);
